import { loan_application } from '@axo/shared/data-access/types';
import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';

export const getApplicationValidationStatus =
  ({ url: { service: baseURL }, token }: IAPI) =>
  (
    applicationID: string,
  ): Promise<loan_application.LoanApplicationValidation> =>
    send<undefined, loan_application.LoanApplicationValidation>({
      baseURL,
      path: `/loan-application/check/app/${encodeURIComponent(applicationID)}`,
      method: 'GET',
      token,
    });

export const validateApplication = (
  { url: { service: baseURL }, token }: IAPI,
  application: loan_application.LoanApplication,
) =>
  send<
    loan_application.LoanApplication,
    loan_application.LoanApplicationValidation
  >({
    baseURL,
    path: `/loan-application/check/app`,
    method: 'POST',
    body: application,
    token,
  });
